import React, { useState } from 'react'
import { Table } from 'react-bootstrap'
import { BlockError, ChartSkeleton } from '../BlockState'
import { CardTitle } from '../InfoButton'

// Tabela gêmea do gráfico: a primeira coluna é o rótulo, as outras são números alinhados à direita
export const DataTable = ({ head, rows }) => (
  <Table size='sm' className='dashboard-table mb-0'>
    <thead>
      <tr>{head.map((title, index) => <th key={index} className={index ? 'text-end' : ''}>{title}</th>)}</tr>
    </thead>
    <tbody>
      {rows.map((row, rowIndex) => (
        <tr key={rowIndex}>{row.map((cell, index) => <td key={index} className={index ? 'text-end dashboard-num' : ''}>{cell}</td>)}</tr>
      ))}
    </tbody>
  </Table>
)

// Cartão de gráfico: título, legenda, Ver tabela (a mesma informação sem cor e sem mouse) e os estados do bloco.
// skeleton: primeira carga · stale: trocando o filtro (o desenho anterior fica esmaecido) · empty: sem dado no período ·
// info: chave do INDICATOR_INFO (o "i" ao lado do título)
const ChartCard = ({
  title, info, subtitle, legend, tools, wide = false, renderTable,
  skeleton = false, error = '', onRetry, stale = false, empty = false, emptyText = 'Nenhum atendimento no período',
  height = 240, footer, children,
}) => {
  const [showTable, setShowTable] = useState(false)
  const ready = !skeleton && !error && !empty

  return (
    <section className={`dashboard-card ${wide ? 'dashboard-card-wide' : ''}`} aria-label={typeof title === 'string' ? title : undefined}>
      <div className='dashboard-card-head'>
        <div className='dashboard-card-heading'>
          <CardTitle title={title} info={info} />
          {subtitle ? <p className='dashboard-card-sub'>{subtitle}</p> : ''}
        </div>
        <div className='dashboard-card-tools'>
          {ready && !showTable ? legend : ''}
          {tools}
          {ready && renderTable ?
            <button type='button' className='dashboard-link-button' aria-pressed={showTable} onClick={() => setShowTable((value) => !value)}>
              {showTable ? 'Ver gráfico' : 'Ver tabela'}
            </button>
            : ''}
        </div>
      </div>

      {error ?
        <BlockError message={error} onRetry={onRetry} />
        : skeleton ?
          <ChartSkeleton height={height} />
          : empty ?
            <p className='dashboard-empty'>{emptyText}</p>
            :
            <div className={stale ? 'dashboard-stale' : ''} aria-busy={stale}>
              {showTable ? <div className='dashboard-table-wrap'>{renderTable()}</div> : children}
            </div>
      }

      {ready && footer ? <div className={`dashboard-card-footer ${stale ? 'dashboard-stale' : ''}`}>{footer}</div> : ''}
    </section>
  )
}

export default ChartCard
